import {
  PanelBody,
  SelectControl,
  __experimentalInputControl as InputControl,
  __experimentalDivider as Divider,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";

export default function AllInspectorSettings({ attributes, setAttributes }) {
  const {
    action,
    successUrl,
    successMessage,
    failedUrl,
    failedMessage,
    method,
    formAction,
    redirectUrl,
  } = attributes;

  return (
    <>
      <PanelBody title={__("Settings")}>
        <SelectControl
          label={__("Action")}
          value={action}
          options={[
            { label: "Login", value: "login" },
            { label: "Reset password", value: "reset_password" },
            { label: "Contact us", value: "contact_us" },
            { label: "Custom", value: "custom" },
            { label: "Other link", value: "other_link" },
          ]}
          onChange={(v) => setAttributes({ action: v })}
          help={
            <>
              {action === "login" &&
                __(
                  "Please make sure you have two fields with name: username - password"
                )}
              {action === "reset_password" &&
                __("Please make sure you have field: user_login")}
              {action === "other_link" &&
                __(
                  "On submit, the user will be redirected to the URL. Use [field_name] to insert form field values."
                )}
            </>
          }
          __nextHasNoMarginBottom
          __next40pxDefaultSize={true}
        />
        {action === "custom" && (
          <>
            <SelectControl
              label={__("Method")}
              value={method || "post"}
              options={[
                { label: "POST", value: "post" },
                { label: "GET", value: "get" },
              ]}
              onChange={(v) => setAttributes({ method: v })}
              __nextHasNoMarginBottom
            />
            <InputControl
              label={__("Action Name")}
              value={formAction || ""}
              onChange={(v) => setAttributes({ formAction: v })}
              placeholder={__("Enter action name")}
              help={__("The name of the action to be executed")}
            />
            <Divider />
          </>
        )}
        {action === "other_link" && (
          <InputControl
            label={__("Redirect URL")}
            value={redirectUrl || ""}
            onChange={(v) => setAttributes({ redirectUrl: v })}
            placeholder={__("https://example.com/page/[field_name]")}
            help={__(
              "Use [field_name] placeholders to insert form field values into the URL."
            )}
          />
        )}
        {action !== "reset_password" && action !== "other_link" && (
          <>
            <InputControl
              label={__("Success redirect url")}
              value={successUrl}
              onChange={(v) => setAttributes({ successUrl: v })}
            />
            <InputControl
              label={__("Failed redirect url")}
              value={failedUrl}
              onChange={(v) => setAttributes({ failedUrl: v })}
            />
            <Divider />
            <InputControl
              label={__("Success message")}
              value={successMessage}
              onChange={(v) => setAttributes({ successMessage: v })}
            />
            <InputControl
              label={__("Failed message")}
              value={failedMessage}
              onChange={(v) => setAttributes({ failedMessage: v })}
            />
          </>
        )}
      </PanelBody>
    </>
  );
}
